module.exports = __webpack_public_path__ + "media/honey-icons/icon-previous-video-ed81ce4d.svg";